import {Container, Col }from 'react-bootstrap';

import Header from '../sections/header';
import Footer from '../sections/footer';
import MainContent from '../sections/maincontent';

function PageNotFound(){
    return (
        <> 
            <Header />
            <Container fluid className="color-bg-secondary">
                    <MainContent>
                        <Col className="fill-container py-4">
                            <div className="d-flex align-items-center justify-content-center">
                                <p className="text-start font-body color-font-primary font-size-large">404 Not Found</p>
                            </div>
                        </Col>
                    </MainContent>
            </Container>
            <Footer />
        </>
    )
}

export default PageNotFound;